import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from 'universal-cookie';
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";

const proxy = GetProxy();
const cookies = new Cookies();

// ===================== THUNKS =====================

export const getConfigurationList = createAsyncThunk(
  "post/getConfigurationList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Configuration List : ", error);
      throw error;
    }
  },
);

export const getDivisionMappingList = createAsyncThunk(
  "post/getDivisionMappingList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/divisionMapping/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Division Mapping List: ", error);
      throw error;
    }
  },
);

export const getCommonPool = createAsyncThunk(
  "post/getCommonPool",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/common-pool`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Worktag ID: ", error);
      throw error;
    }
  },
);

export const getTpaList = createAsyncThunk(
  "get/getTpaList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/tpa-configuration/${pageNumber}/${itemsPerPage}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting TPA List : ", error);
      throw error;
    }
  },
);

export const getTpaById = createAsyncThunk(
  "get/getTpaById",
  async (props) => {
    try {
      const { id } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/tpa-configuration/${id}/info`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting TPA by ID : ", error);
      throw error;
    }
  },
);

export const createTpa = createAsyncThunk(
  "post/createTpa",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/tpa-configuration/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in creating TPA : ", error);
      throw error;
    }
  },
);

export const updateTpa = createAsyncThunk(
  "post/updateTpa",
  async (props) => {
    try {
      const { id, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/tpa-configuration/update/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in updating TPA : ", error);
      throw error;
    }
  },
);

export const deleteTpa = createAsyncThunk(
  "delete/deleteTpa",
  async (props) => {
    try {
      const { id } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/tpa-configuration/${id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in deleting TPA : ", error);
      throw error;
    }
  },
);

export const getCsdList = createAsyncThunk(
  "get/getCsdList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/${pageNumber}/${itemsPerPage}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting CSD List : ", error);
      throw error;
    }
  },
);

export const getCsdById = createAsyncThunk(
  "get/getCsdById",
  async (props) => {
    try {
      const { id } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/${id}/info`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting CSD by ID : ", error);
      throw error;
    }
  },
);

export const createCsd = createAsyncThunk(
  "post/createCsd",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in creating CSD : ", error);
      throw error;
    }
  },
);

export const updateCsd = createAsyncThunk(
  "post/updateCsd",
  async (props) => {
    try {
      const { id, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/update/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in updating CSD : ", error);
      throw error;
    }
  },
);

export const updateCsdStatus = createAsyncThunk(
  "post/updateCsdStatus",
  async (props) => {
    try {
      const { id, payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/updateStatus/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in updating CSD Status : ", error);
      throw error;
    }
  },
);

export const deleteCsd = createAsyncThunk(
  "delete/deleteCsd",
  async (props) => {
    try {
      const { id } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/csd-configuration/${id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const text = await response.text();
      if (!response.ok) {
        let errData;
        try { errData = JSON.parse(text); } catch { errData = { message: text }; }
        return Promise.reject(errData);
      }
      try { return JSON.parse(text); } catch { return text; }
    } catch (error) {
      console.log("Error in deleting CSD : ", error);
      throw error;
    }
  },
);

export const getFilterList = createAsyncThunk(
  "post/getFilterList",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/getFilterList`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Filter List : ", error);
      throw error;
    }
  },
);

export const downloadConfigurationTemplate = createAsyncThunk(
  "get/downloadConfigurationTemplate",
  async (props) => {
    try {
      const type = props?.type || "CapexAndOpexConfig";
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/template?type=${type}`,
        {
          method: "GET",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.blob();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in downloading Configuration Template : ", error);
      throw error;
    }
  },
);

export const importConfigurationFile = createAsyncThunk(
  "post/importConfigurationFile",
  async (props, { rejectWithValue }) => {
    try {
      const { formData } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/import`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: formData,
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in importing Configuration File : ", error);
      throw error;
    }
  },
);

export const getSupplierList = createAsyncThunk(
  "post/getSupplierList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, keyword } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const body = { keyword: keyword || "" };
      const response = await fetch(
        `${proxy}/api/v1/supplier/supplierList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(body),
        },
      );
      handleResponseCode(response);
      const data = response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in getting Supplier List : ", error);
      throw error;
    }
  },
);

export const importSupplierDetails = createAsyncThunk(
  "post/importSupplierDetails",
  async (props, { rejectWithValue }) => {
    try {
      const { formData } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/supplier/importSupplierDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: formData,
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || data.statusCode !== 200) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in importing Supplier Details : ", error);
      throw error;
    }
  },
);

export const deleteSupplier = createAsyncThunk(
  "delete/deleteSupplier",
  async (props, { rejectWithValue }) => {
    try {
      const { id } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/supplier/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || data.statusCode !== 200) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in deleting Supplier : ", error);
      throw error;
    }
  },
);

// Create a single supplier name manually
export const createSupplier = createAsyncThunk(
  "post/createSupplier",
  async (props, { rejectWithValue }) => {
    try {
      const { supplierName } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/supplier/saveSupplierName`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify({ supplierName }),
        },
      );
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || data.statusCode !== 200) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.log("Error in creating Supplier : ", error);
      throw error;
    }
  },
);

export const downloadSupplierTemplate = createAsyncThunk(
  "get/downloadSupplierTemplate",
  async (props) => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/configuration/templateXLSXForSupplierName`,
        {
          method: "GET",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        },
      );
      handleResponseCode(response);
      const data = await response.blob();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error in downloading Supplier Template : ", error);
      throw error;
    }
  },
);

// Fetch email schedule list for Budget Module
export const getEmailScheduleList = createAsyncThunk(
  "post/getEmailScheduleList",
  async (props) => {
    try {
      const { pageNumber, itemsPerPage, keyword } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/bMEmailScheduler/list/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify({ keyword: keyword || "" }),
      });
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error fetching email schedule list:", error);
      throw error;
    }
  },
);

// Save or update email schedule for Budget Module
export const saveEmailSchedule = createAsyncThunk(
  "post/saveEmailSchedule",
  async (payload, { rejectWithValue }) => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/bMEmailScheduler/save`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || (data.statusCodeValue !== 200 && data.statusCodeValue !== 201)) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.error("Error saving email schedule:", error);
      throw error;
    }
  },
);

// Update email schedule active status
export const updateEmailScheduleStatus = createAsyncThunk(
  "post/updateEmailScheduleStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/bMEmailScheduler/updateStatus`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || (data.statusCodeValue !== 200 && data.statusCodeValue !== 201)) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.error("Error updating email schedule status:", error);
      throw error;
    }
  },
);

// Delete email schedule by ID
export const deleteEmailSchedule = createAsyncThunk(
  "delete/deleteEmailSchedule",
  async (id, { rejectWithValue }) => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/bMEmailScheduler/delete/${id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      });
      handleResponseCode(response);
      const data = await response.json();
      if (!response.ok || (data.statusCodeValue !== 200 && data.statusCodeValue !== 201)) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      console.error("Error deleting email schedule:", error);
      throw error;
    }
  },
);

// Fetch available email schedule types for Budget Module
export const getAvailableEmailTypes = createAsyncThunk(
  "get/getAvailableEmailTypes",
  async () => {
    try {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/bMEmailScheduler/availableEmailTypes`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      });
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error fetching available email types:", error);
      throw error;
    }
  },
);

// ===================== INITIAL STATE =====================

const initialState = {
  configurationList: {},
  divisionMappingList: {},
  divisionMappingLoading: false,
  configurationLoading: false,
  commonPoolData: {},
  commonPoolLoading: false,
  tpaList: {},
  tpaLoading: false,
  csdList: {},
  csdLoading: false,
  filterList: {},
  filterLoading: false,
  supplierList: {},
  supplierLoading: false,
  emailScheduleList: {},
  emailScheduleListLoading: false,
  availableEmailTypes: [],
  availableEmailTypesLoading: false,
  error: "",
  apierror: false,
};

// ===================== SLICE =====================

export const ConfigurationSlice = createSlice({
  name: "budgetConfigurationSlice",
  initialState,
  reducers: {
    resetConfigurationData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfigurationList.pending, (state, action) => {
        state.configurationLoading = true;
        state.configurationList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getConfigurationList.fulfilled, (state, action) => {
        state.configurationLoading = false;
        state.configurationList = action.payload;
        state.apierror = false;
      })
      .addCase(getConfigurationList.rejected, (state, action) => {
        state.configurationLoading = false;
        state.configurationList = {};
        state.error = "something went wrong";
        state.apierror = true;
      })
      .addCase(getDivisionMappingList.pending, (state) => {
        state.divisionMappingLoading = true;
        state.divisionMappingList = {};
      })
      .addCase(getDivisionMappingList.fulfilled, (state, action) => {
        state.divisionMappingLoading = false;
        state.divisionMappingList = action.payload;
      })
      .addCase(getDivisionMappingList.rejected, (state) => {
        state.divisionMappingLoading = false;
        state.divisionMappingList = {};
      })
      .addCase(getCommonPool.pending, (state, action) => {
        state.commonPoolLoading = true;
        state.commonPoolData = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getCommonPool.fulfilled, (state, action) => {
        state.commonPoolLoading = false;
        state.commonPoolData = action.payload;
        state.apierror = false;
      })
      .addCase(getCommonPool.rejected, (state, action) => {
        state.commonPoolLoading = false;
        state.commonPoolData = {};
        state.apierror = true;
      })
      .addCase(getTpaList.pending, (state, action) => {
        state.tpaLoading = true;
        state.tpaList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getTpaList.fulfilled, (state, action) => {
        state.tpaLoading = false;
        state.tpaList = action.payload;
        state.apierror = false;
      })
      .addCase(getTpaList.rejected, (state, action) => {
        state.tpaLoading = false;
        state.tpaList = {};
        state.apierror = true;
      })
      .addCase(getCsdList.pending, (state, action) => {
        state.csdLoading = true;
        state.csdList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getCsdList.fulfilled, (state, action) => {
        state.csdLoading = false;
        state.csdList = action.payload;
        state.apierror = false;
      })
      .addCase(getCsdList.rejected, (state, action) => {
        state.csdLoading = false;
        state.csdList = {};
        state.apierror = true;
      })
      .addCase(getFilterList.pending, (state, action) => {
        state.filterLoading = true;
        state.filterList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getFilterList.fulfilled, (state, action) => {
        state.filterLoading = false;
        state.filterList = action.payload;
        state.apierror = false;
      })
      .addCase(getFilterList.rejected, (state, action) => {
        state.filterLoading = false;
        state.filterList = {};
        state.apierror = true;
      })
      .addCase(getSupplierList.pending, (state, action) => {
        state.supplierLoading = true;
        state.supplierList = {};
        state.error = "";
        state.apierror = false;
      })
      .addCase(getSupplierList.fulfilled, (state, action) => {
        state.supplierLoading = false;
        state.supplierList = action.payload;
        state.apierror = false;
      })
      .addCase(getSupplierList.rejected, (state, action) => {
        state.supplierLoading = false;
        state.supplierList = {};
        state.apierror = true;
      })
      .addCase(getEmailScheduleList.pending, (state) => {
        state.emailScheduleListLoading = true;
      })
      .addCase(getEmailScheduleList.fulfilled, (state, action) => {
        state.emailScheduleListLoading = false;
        state.emailScheduleList = action.payload;
      })
      .addCase(getEmailScheduleList.rejected, (state) => {
        state.emailScheduleListLoading = false;
        state.emailScheduleList = {};
      })
      .addCase(getAvailableEmailTypes.pending, (state) => {
        state.availableEmailTypesLoading = true;
      })
      .addCase(getAvailableEmailTypes.fulfilled, (state, action) => {
        state.availableEmailTypesLoading = false;
        state.availableEmailTypes = action.payload;
      })
      .addCase(getAvailableEmailTypes.rejected, (state) => {
        state.availableEmailTypesLoading = false;
        state.availableEmailTypes = [];
      });
  },
});

export const { resetConfigurationData } = ConfigurationSlice.actions;
export default ConfigurationSlice.reducer;